import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(function Input(
  { className, type, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "bg-background text-foreground border-border placeholder:text-muted-foreground",
        "selection:bg-primary selection:text-primary-foreground",
        "flex h-9 w-full rounded-md border px-3 py-1 text-sm",
        "focus-visible:border-ring focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20",
        className
      )}
      {...props} />
  );
});

export { Input }
